import { Typography, Grid, Divider } from '@mui/material';
import { List, ListItem } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@mui/material/styles';
import { translate } from '@lwtears/lwt-common-frontend/lib/@common/util/i18n-util';
import StudentList from './StudentList';
import { Student } from 'types';
import { FormattedAssessmentOutcomes } from 'types/formatted-assessment-outcomes';

const t = (key: string, options?) => translate('ui', key, options);

const PrintableSection = (props: {
  students: Student[];
  outcomes: FormattedAssessmentOutcomes;
}): React.ReactElement => {
  const classes = useStyles();

  return (
    <>
      <Typography variant="h2" component="h2" className={classes.sectionHeader}>
        {props.outcomes.label}
      </Typography>

      <Grid container item xs={12}>
        <Grid item xs={6}>
          <StudentList
            score={3}
            studentIds={props.outcomes.meets}
            students={props.students}
            showNumberedList={true}
          />
        </Grid>
        <Grid item xs={6}>
          <StudentList
            score={2}
            studentIds={props.outcomes.growing}
            students={props.students}
            showNumberedList={true}
          />
        </Grid>
        <Grid item xs={6}>
          <StudentList
            score={1}
            studentIds={props.outcomes.early}
            students={props.students}
            showNumberedList={true}
          />
        </Grid>
        <Grid item xs={6}>
          <StudentList
            score={0}
            studentIds={props.outcomes.notTested}
            students={props.students}
            showNumberedList={true}
          />
        </Grid>
      </Grid>

      {props?.outcomes?.remediations && (
        <>
          <Typography component="h2" variant="h2">
            {t('class.recommendations')}
          </Typography>
          <Divider />
          <List>
            {props.outcomes.remediations.map((remediation) => {
              return (
                <ListItem key={remediation.id}>
                  <Typography
                    dangerouslySetInnerHTML={{
                      __html: remediation.text.replace(
                        /\*{2}([^*]+)\*{2}/g,
                        "<span style='font-family: HWT Futura Semi Bold'>$1</span>"
                      ),
                    }}
                  />
                </ListItem>
              );
            })}
          </List>
        </>
      )}
    </>
  );
};

export default PrintableSection;

const useStyles = makeStyles((theme: Theme) => {
  return {
    pb4: {
      paddingBottom: theme.spacing(4),
    },
    sectionHeader: {
      color: theme.palette.primary.main,
    },
    grayLine: {
      height: '1px !important',
      backgroundColor: '#EAEAEA !important',
    },
  };
});
